import { render, staticRenderFns } from "./BaseDataTableTableHead.vue?vue&type=template&id=074d2414"
import script from "./BaseDataTableTableHead.vue?vue&type=script&lang=js"
export * from "./BaseDataTableTableHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports